module.exports = __webpack_public_path__ + "media/application/images/icons/logo-14eaa9fc74796d0f50aa8d4d1ae8fa09.png";